import { URLObject } from '@kalos/kalos-rpc';

import { getEnhancedMimeType, S3ClientService } from '../tools/helpers';

/** Download an S3 object by file record and return a data URL (used for image previews). */
export async function fetchS3FileRecordAsDataUrl(file: {
  name: string;
  bucket: string;
}): Promise<string | null> {
  try {
    if (!file.name || !file.bucket) {
      return null;
    }

    const url = URLObject.create({
      bucket: file.bucket,
      key: file.name,
    });

    const urlRes = await S3ClientService.GetDownloadURL(url);
    if (!urlRes?.url) {
      return null;
    }

    const downloadRes = await fetch(urlRes.url);
    if (downloadRes.status !== 200) {
      return null;
    }

    const arrayBuffer = await downloadRes.arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);
    let binaryString = '';
    for (let i = 0; i < uint8Array.length; i++) {
      binaryString += String.fromCharCode(uint8Array[i]);
    }
    const base64String = btoa(binaryString);
    const mimeType = getEnhancedMimeType(file.name, uint8Array);
    return `data:${mimeType};base64,${base64String}`;
  } catch {
    return null;
  }
}
